import { render, staticRenderFns } from "./IconStatusBadge.vue?vue&type=template&id=3dcc7a38"
import script from "./IconStatusBadge.vue?vue&type=script&lang=js"
export * from "./IconStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports